import React from 'react'
import { WHOLESALE } from '../config/wholesale'

const WholesaleSpecsTable: React.FC = () => {
  return (
    <section className="relative z-10" style={{ backgroundColor: '#0d0d0d' }}>
      <div className="container mx-auto px-6 py-8 max-w-4xl">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold !text-white font-heading">
            Product Specifications
          </h2>
          <p className="mt-3 !text-white/60 font-body max-w-2xl mx-auto">
            Exact operational data for your kitchen.
          </p>
        </div>

        {/* Inner overflow-x-auto so wide spec details scroll horizontally on
            narrow iOS viewports instead of being clipped by overflow-hidden. */}
        <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden">
          <div className="overflow-x-auto">
          <table className="w-full min-w-[360px]">
            <thead>
              <tr className="border-b border-white/10">
                <th className="text-left px-5 md:px-6 py-4 text-base md:text-lg font-bold !text-white font-heading">
                  Specification
                </th>
                <th className="text-left px-5 md:px-6 py-4 text-base md:text-lg font-bold !text-white font-heading">
                  Detail
                </th>
              </tr>
            </thead>
            <tbody>
              {WHOLESALE.specs.map((spec, index) => (
                <tr
                  key={spec.label}
                  className={index < WHOLESALE.specs.length - 1 ? 'border-b border-white/5' : ''}
                >
                  <td className="px-5 md:px-6 py-3 md:py-4 text-sm md:text-base font-semibold !text-white/90">
                    {spec.label}
                  </td>
                  <td className="px-5 md:px-6 py-3 md:py-4 text-sm md:text-base !text-white/60 font-body">
                    {spec.detail}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WholesaleSpecsTable
